import BanzaiCollectionsService from '@/services/banzai-collections.service'
import {AxiosInstance} from 'axios'
import _Vue from 'vue'

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    Vue.prototype.$banzaiCollections = new BanzaiCollectionsService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiCollections: BanzaiCollectionsService;
  }
}
